import HttpRequest from "@/plugins/axios";

class UserProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_URL);
  }

  async login(username, password) {
    const { data } = await this.post("/", {
      function: "login",
      username: username,
      password: password,
    });
    return data;
  }

  async getUserInfo(uid, student_id) {
    const { data } = await this.get("/", {
      function: "get-user-info",
      uid: uid,
      student_id: student_id,
    });
    return data;
  }

  async logAccessKmitl1(student_id) {
    const { data } = await this.post("/", {
      function: "log-access-kmitl1",
      student_id: student_id,
    });
    return data;
  }

  async requestPassword(register_id, citizen_id) {
    const { data } = await this.post("/", {
      function: "request-password",
      register_id: register_id,
      citizen_id: citizen_id,
    });
    return data;
  }

  async checkPassword(secure_key) {
    const { data } = await this.post("/", {
      function: "check-password",
      secure_key: secure_key,
    });
    return data;
  }

  async setPassword(secure_key, password) {
    const { data } = await this.post("/", {
      function: "set-password",
      secure_key: secure_key,
      password: password,
    });
    return data;
  }

  async getUIDbyRegisterID(register_id) {
    const { data } = await this.get("/", {
      function: "get-uid-by-register-id",
      register_id: register_id,
    });
    return data;
  }

  async getUIDforInfo(id, type) {
    const { data } = await this.get("/", {
      function: "get-uid-for-info",
      id: id,
      type: type,
    });
    return data;
  }

  async getOverallUploadStatus(uid) {
    const { data } = await this.get("/", {
      function: "get-overall-upload-status",
      uid: uid,
    });
    return data;
  }

  async getLock(uid, type) {
    const { data } = await this.get("/", {
      function: "get-lock",
      uid: uid,
      type: type,
    });
    return data;
  }

  async getStatusAndCommentPhoto(uid) {
    const { data } = await this.get("/", {
      function: "get-status-and-comment-photo",
      uid: uid,
    });
    return data;
  }

  async saveStatusAndCommentPhoto(info) {
    const { data } = await this.update("/", {
      function: "save-status-and-comment-photo",
      uid: info.uid,
      STATUS: info.status,
      COMMENT: info.comment,
    });
    return data;
  }

  async getCommentDocument(uid) {
    const { data } = await this.get("/", {
      function: "get-document",
      uid: uid,
    });
    return data;
  }

  async setLock(info) {
    const { data } = await this.create("/", {
      function: "set-lock",
      uid: info.uid,
      type: info.type,
      value: info.value,
    });
    return data;
  }

  async setMatriculationStatus(info) {
    const { data } = await this.create("/", {
      function: "set-matriculation-status",
      uid: info.uid,
      value: info.value,
    });
    return data;
  }

  async getMatriculationStatusStd(uid) {
    const { data } = await this.get("/", {
      function: "get-matriculation-status",
      uid: uid,
    });
    return data;
  }

  async saveDefaultData(info) {
    const { data } = await this.update("/", {
      function: "save-default-data",
      uid: info.uid,
      CITIZEN_ID: info.CITIZEN_ID,
      STUDENT_FNAME_TH: info.STUDENT_FNAME_TH,
      STUDENT_LNAME_TH: info.STUDENT_LNAME_TH,
    });
    return data;
  }

  async isRoundLock(level_id) {
    const { data } = await this.get("/", {
      function: "is-round-lock",
      level_id: level_id,
    });
    return data;
  }

  async getHasCommentDocument(uid) {
    const { data } = await this.get("/", {
      function: "is-has-comment-document",
      uid: uid,
    });
    return data;
  }

  async sendEmailNotComplete(uid) {
    const { data } = await this.create("/", {
      function: "send-email-not-complete",
      uid: uid,
    });
    return data;
  }
}

export default UserProvider;
